import { Store } from 'vuex';
import { Actions, Context } from 'vuex-smart-module';
import { ProductShared } from '@/modules/products/shared/types';
import { Products } from '@/modules/products/types';
import CartStore from '../../store';
import CartState from '../../store/state';
import CartSharedGetters from './getters';
import CartSharedMutations from './mutations';
import CartSharedState from './state';
import { Cart } from '../../types';
import CatalogProductItem = Products.CatalogProductItem;

type num_null = number | null;
export default class CartSharedActions extends Actions<
  CartSharedState,
  CartSharedGetters,
  CartSharedMutations,
  CartSharedActions
> {
  cart_store!: Context<typeof CartStore>;

  $init(store: Store<CartState>): void {
    this.cart_store = CartStore.context(store);
  }

  find_in_cart(product: ProductShared) {
    return this.getters.products_in_cart.find((elem) => elem.product.id === product.id);
  }

  find_in_cart1(product: CatalogProductItem) {
    return this.getters.products_in_cart.find((elem) => elem.product.id === product.id);
  }

  async add_to_cart(product: ProductShared | ProductShared[]) {
    const data = await this.cart_store.actions.add_to_cart({ product, warehouse_id: null });

    return data;
  }

  async add_to_cart1(product: Products.CatalogProductItem | Products.CatalogProductItem[]) {
    const data = await this.cart_store.actions.add_to_cart1({ product, warehouse_id: null });

    return data;
  }

  async del_from_cart(payload: Cart.CartUpdPayloadProduct) {
    const item = await this.dispatch('find_in_cart', payload.product) as Cart.CartItem;

    const { warehouse_id, project_id } = payload;

    if (typeof item?.id !== 'undefined') {
      this.cart_store.actions.del_from_cart({
        id: item.id,
        warehouse_id,
        project_id,
        is_selected: item.is_selected,
      });
    }
  }

  async upd_item_cart_quantity(payload: Cart.CartUpdPayloadProduct) {
    const {
      product, warehouse_id, project_id,
    } = payload;

    if (typeof product.id !== 'undefined' && typeof product.quantity !== 'undefined') {
      const item = await this.dispatch('find_in_cart', product) as Cart.CartItem;

      if (typeof item?.id !== 'undefined') {
        const upd_quantity = this.cart_store.actions.upd_item_cart_quantity;

        upd_quantity({
          product: { id: item.id, quantity: product.quantity, is_selected: item.is_selected }, warehouse_id, project_id,
        });
      }
    }
  }

  async upd_item_cart_quantity1(payload: Cart.CartUpdPayloadProduct1) {
    const {
      product, warehouse_id, project_id,
    } = payload;

    if (typeof product.id !== 'undefined' && typeof product.quantity !== 'undefined') {
      const item = await this.dispatch('find_in_cart1', product) as Cart.CartItem;

      if (typeof item?.id !== 'undefined') {
        const upd_quantity = this.cart_store.actions.upd_item_cart_quantity;

        upd_quantity({
          product: { id: item.id, quantity: product.quantity, is_selected: true }, warehouse_id, project_id,
        });
      }
    }
  }

  get_cart() {
    this.cart_store.actions.get_cart();
  }
}
